import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Users, BookOpen, Calendar, TrendingUp } from "lucide-react";
import BenefitsSection from "@/components/BenefitsSection";

const Benefits = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-4">
        <div className="container mx-auto max-w-4xl text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-foreground">
            Member Benefits
          </h1>
          <p className="text-lg text-muted-foreground mb-8 max-w-3xl mx-auto">
            Join the Referral Connection Network to expand your professional circle and access exclusive resources tailored to your business needs. Our vibrant community fosters collaboration and growth, empowering members through shared insights and referrals.
          </p>
        </div>
      </section>

      {/* Benefits Section */}
      <BenefitsSection />

      {/* Additional Benefits */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-6xl">
          <h2 className="text-3xl font-bold text-center mb-4 text-foreground">
            Unlock Exclusive Member Advantages
          </h2>
          <p className="text-center text-muted-foreground mb-12 max-w-3xl mx-auto">
            Joining the Referral Connection Network opens doors to a wealth of opportunities. Members enjoy exclusive access to resources and events that are designed to foster growth and collaboration. Our community is committed to helping each other succeed.
          </p>
          
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <Card className="border-border hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                  <Users className="w-6 h-6 text-primary" />
                </div>
                <CardTitle>Networking Power</CardTitle>
                <CardDescription>
                  Expand your professional circle with our dynamic networking events that connect you with like-minded professionals.
                </CardDescription>
              </CardHeader>
            </Card>

            <Card className="border-border hover:shadow-lg transition-shadow">
              <CardHeader>
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                  <BookOpen className="w-6 h-6 text-primary" />
                </div>
                <CardTitle>Resource Access</CardTitle>
                <CardDescription>
                  Gain access to valuable resources that support your business growth and enhance your professional skills.
                </CardDescription>
              </CardHeader>
            </Card>
          </div>

          {/* Rules CTA */}
          <Card className="bg-muted/50 border-border">
            <CardContent className="p-8 text-center">
              <h3 className="text-2xl font-bold mb-4 text-foreground">
                View our Group Rules for Members
              </h3>
              <p className="text-muted-foreground mb-6">
                Learn about our member guidelines and expectations to make the most of your RCN membership.
              </p>
              <Button asChild size="lg">
                <a href="/rules">
                  RCN Rules
                </a>
              </Button>
            </CardContent>
          </Card>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Benefits;
